import { propertyNames } from './../../app/app.constants';
import { Injectable } from '@angular/core';
import { Device } from '@ionic-native/device';
import { Geolocation } from '@ionic-native/geolocation';
import { Observable } from 'rxjs/Observable';

import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { Check } from '../../models/check';
import { Coords } from '../../models/coords';
import { QueryModel } from '../../models/query';
import { FirebaseProvider } from '../firebase/firebase';
import { RepoProvider } from '../repo/repo';
import { TimetableProvider } from '../timetable/timetable';
import { WorkplaceProvider } from '../workplace/workplace';

declare var google;

@Injectable()
export class CheckProvider {

  constructor(
    public device: Device,
    public firebaseService: FirebaseProvider,
    public geolocation: Geolocation,
    public globalVars: GlobalVars,
    public repoProvider: RepoProvider,
    public timetableProvider: TimetableProvider,
    public workplaceProvider: WorkplaceProvider,
  ) {}

  /**
   * Crear un fitxatge segons tipus i horari. Es comproven els requeriments
   * del repositori, el centre de treball i el retard.
   * 
   * @param type Tipus de fitxatge (entrada, pausa, rempendre, sortida).
   * @param timetable Horari seleccionat.
   */
  createCheck(type: string, timetable: string, user?, workplace?): Promise<any> {

    return new Promise((resolve, reject) => {
      this.repoProvider.getPropertiesOnce().subscribe(properties => {
        if(!properties.uuid_device || (properties.uuid_device && user.uuid_device == this.device.uuid)) { // **************************************
          
          // Cas que es requereix la ubicació
          if(!workplace) {
            this.geolocation.getCurrentPosition({ enableHighAccuracy: true }).then(resp => {
              this.getCurrentWorkplace(resp).then(workplaceName => {
  
                var timestamp = new Date(resp.timestamp);
  
                var data = { 
                  coords: { lat: (resp.coords.latitude), lng: (resp.coords.longitude) } as Coords,
                  timestamp: timestamp.getTime(),
                  timetable: timetable,
                  type: type,
                  userName: user.name,
                  userKey: user.key,
                  workplace: workplaceName,
                } as Check
  
                this.timetableProvider.getTimetableOnce(timetable).subscribe(timetable => {
                  
                  if(type == "Entrada" || type == "Salida") {
                    var retard = this.calculateDelay(type, timestamp, timetable);
                    data['delay'] = retard;
                    data['delayString'] = msToTime(retard);
                  }
                  
                  this.sendCheck(data).then(() => resolve(true)).catch(error => reject(`Error al acceder a la base de datos.`));
                })
              }).catch(error => reject(`Lugar de fichaje desconocido.`));
            }).catch(error => reject(/*`Error al recuperar coordenadas.`*/ error.code + '\n' + error.message))    
          }

          // Cas del fitxador (no requereix fitxador)
          else {
            var timestamp = new Date();
  
            var data = { 
              timestamp: timestamp.getTime(),
              timetable: timetable,
              type: type,
              userName: user.name,
              userKey: user.key,
              workplace: workplace,
            } as Check

            this.timetableProvider.getTimetableOnce(timetable).subscribe(timetable => {
              
              if(type == "Entrada" || type == "Salida") {
                var retard = this.calculateDelay(type, timestamp, timetable);
                data['delay'] = retard;
                data['delayString'] = msToTime(retard);
              }
              
              this.sendCheck(data).then(() => resolve(true)).catch(error => reject(`Error al acceder a la base de datos.`));
            })
          }
        }
        else reject(`Este dispositivo no está registrado.`)
      })
    })
  }

  createInvalidCheck(type: string, timetable: string, user): Promise<any> {

    return new Promise((resolve, reject) => {

      this.repoProvider.getPropertiesOnce().subscribe(properties => {
        if(!properties.uuid_device || (properties.uuid_device && user.uuid_device == this.device.uuid)) { // **************************************
          this.geolocation.getCurrentPosition({ enableHighAccuracy: true }).then(resp => {
            this.getCurrentWorkplace(resp).then(workplaceName => {

              var timestamp = new Date(resp.timestamp);

              var data = { 
                coords: { lat: (resp.coords.latitude), lng: (resp.coords.longitude) } as Coords,
                timestamp: timestamp.getTime(),
                timetable: timetable,
                type: type,
                userName: user.name,
                userKey: user.key,
                workplace: workplaceName,
              } as Check

              this.timetableProvider.getTimetableOnce(timetable).subscribe(timetable => {
                
                if(type == "Entrada" || type == "Salida") {
                  var retard = this.calculateDelay(type, timestamp, timetable);
                  data['delay'] = retard;
                  data['delayString'] = msToTime(retard);
                }
                
                this.sendCheck(data).then(() => resolve(true)).catch(error => reject(`Error al acceder a la base de datos.`));
              })
            }).catch(error => {
              var timestamp = new Date(resp.timestamp);

              var data = { 
                coords: { lat: (resp.coords.latitude), lng: (resp.coords.longitude) } as Coords,
                timestamp: timestamp.getTime(),
                timetable: timetable,
                type: type,
                userName: user.name,
                userKey: user.key,
                workplace: error,
              } as Check

              this.timetableProvider.getTimetableOnce(timetable).subscribe(timetable => {
                
                if(type == "Entrada" || type == "Salida") {
                  var retard = this.calculateDelay(type, timestamp, timetable);
                  data['delay'] = retard;
                  data['delayString'] = msToTime(retard);
                }
                
                this.sendCheck(data).then(() => resolve(true)).catch(error => reject(`Error al acceder a la base de datos.`));
              })
            })
          }).catch(error => reject(`Error al recuperar coordenadas.`));
        }
        else reject(`Este dispositivo no está registrado.`)
      })
    })
  }

  /**
   * Recuperar fitxatges entre dues dates.
   * 
   * @param beginDate Data d'inici.
   * @param endDate Data final.
   */
  getChecksBetweenDatesOnce(beginDate: Date, endDate: Date): Observable<Check[]> {
    let query = new QueryModel();
  
    var timestampInici = beginDate.getTime();
    var timestampFinal = endDate.getTime();
    
    query.orderByChild = 'timestamp';
    query.startAt = timestampInici;
    query.endAt = timestampFinal;


    return this.firebaseService.listOnce(this.getBaseRoot() + tableNames.Checks, query);
  }

  /**
   * Recuperar últims [number] fitxatges, amb opció de filtar per data.
   * 
   * @param number Número de fitxatges a recuperar.
   * @param date Data opcional, per filtar.
   */
  getLastChecks(number: number, date?: Date): Observable<Check[]> {
    let query = new QueryModel();

    if(date) {
      var date = new Date(date);
      var dataInici = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
      var dataFinal = new Date(date.getFullYear(), date.getMonth(), date.getDate()+1, 0, 0, 0, 0);
      
      var timestampInici = dataInici.getTime();
      var timestampFinal = dataFinal.getTime();
      
      query.orderByChild = 'timestamp';
      query.startAt = timestampInici;
      query.endAt = timestampFinal;
    }

    query.limitToLast = number;

    return this.firebaseService.list(this.getBaseRoot() + tableNames.Checks, query).map(checks => checks.reverse());
  }

  /**
   * Recuperar últims [number] fitxatges d'un usuari, amb opció de filtar per data.
   * 
   * @param number Número de fitxatges a recuperar.
   * @param userId Uuid opcional, per filtrar. Per defecte es filtra per usuari actual.
   * @param date Data opcional, per filtrar.
   */
  getLastUserChecks(number: number, userId?: string, date?: Date): Observable<Check[]> {
    let query = new QueryModel();

    if(date) {
      var date = new Date(date);
      var dataInici = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
      var dataFinal = new Date(date.getFullYear(), date.getMonth(), date.getDate()+1, 0, 0, 0, 0);
      
      var timestampInici = dataInici.getTime();
      var timestampFinal = dataFinal.getTime();
      
      query.orderByChild = 'timestamp';
      query.startAt = timestampInici;
      query.endAt = timestampFinal;
    }

    query.limitToLast = number;

    return this.firebaseService.list(this.getBaseRoot() + tableNames.UserChecks + '/' + (userId || this.globalVars.user.key), query).map(contacts => contacts.reverse());
  }

  /**
   * Recuperar fitxatges d'un usuari, amb opció de filtar per data.
   * 
   * @param date Data opcional, per filtrar.
   * @param userId Uuid opcional, per filtrar. Per defecte es filtra per usuari actual.
   */
  getUserChecks(date?: Date, userId?: string): Observable<Check[]> {
    let query = new QueryModel();
      
    if(date) {
      var date = new Date(date);
      var beginDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
      var endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()+1, 0, 0, 0, 0);
      
      var timestampBegin = beginDate.getTime();
      var timestampEnd = endDate.getTime();
      
      query.orderByChild = 'timestamp';
      query.startAt = timestampBegin;
      query.endAt = timestampEnd;
    }

    return this.firebaseService.list(this.getBaseRoot() + tableNames.UserChecks + '/' + (userId || this.globalVars.user.key), query).map(checks => checks.reverse());
  }

  /**
   * Recuperar fitxatges entre dues dates d'un usuari.
   * 
   * @param beginDate Data d'inici.
   * @param endDate Data final.
   * @param userId Uuid opcional, per filtrar. Per defecte es filtra per usuari actual.
   */
  getUserChecksBetweenDatesOnce(beginDate: Date, endDate: Date, userId?: string): Observable<Check[]> {
    let query = new QueryModel();

    query.orderByChild = 'timestamp';
    query.startAt = beginDate.getTime();
    query.endAt = endDate.getTime();

    return this.firebaseService.listOnce(this.getBaseRoot() + tableNames.UserChecks + '/' + (userId || this.globalVars.user.key), query);
  }

  /**
   * Modificar un fitxatge.
   * 
   * @param check Fitxatge a modificar.
   * @param key Clau del fitxatge a modificar.
   * @param userId Clau de l'usuari que ha fet el fitxatge
   */
  modifyCheck(check: Check, key: string, userId): Promise<any> {
    var checksPath = tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.Checks + '/';
    var userChecksPath = tableNames.Repo + '/' + this.globalVars.user.repo + '/'+ tableNames.UserChecks + '/' + userId + '/';
    
    var paths = [checksPath, userChecksPath]
    return this.firebaseService.multipleUpdate(paths, key, check);
  }

  /**
   * Eliminar un fitxatge.
   * 
   * @param checkId Identificador del fitxatge a eliminar.
   */
  remove(checkId: string, userId: string): Promise<any> {
    return this.modifyCheck(null, checkId, userId)
  }

  /**
   * Guardar un fitxatge.
   * 
   * @param check Fitxatge a guardar.
   * @param userId Usuari que ha fet el fitxatge.
   */
  save(check: Check, userId: string): Promise<any> {
    if(check.key) {
      var key = check.key;
      delete check.key;
      return this.modifyCheck(check, key, userId)
    }
      
    else return this.sendCheck(check)
  }

  /**
   * Guardar un fitxatge nou.
   * 
   * @param check Fitxatge a enviar.
   * @param userId Usuari que ha fet el fitxatge
   */
  sendCheck(check: Check): Promise<any> {
    var checksPath = tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.Checks + '/';
    var userChecksPath = tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.UserChecks + '/' + check.userKey + '/';
    var statePath = tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.User + '/' + check.userKey;
    var lastUserCheckPath = tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.User + '/' + check.userKey;
    
    var paths = [checksPath, userChecksPath]

    return new Promise((resolve, reject) => {
      this.firebaseService.multiplePush(checksPath, paths, check).then(() => {
        if(check.timetable) 
          this.firebaseService.set(lastUserCheckPath, propertyNames.LastCheck, check).then(() => {
            this.firebaseService.set(statePath, propertyNames.State, check.type).then(() => {
              this.firebaseService.set(statePath, propertyNames.LastTimetable, check.timetable).then(() => {
                resolve(true)
              }).catch(error => reject(error));
            }).catch(error => reject(error));
          }).catch(error => reject(error));
        else resolve(true)  
      }).catch(error => reject(error));
    })
  }

  /**
   * Calcular el retard d'un fitxatge respecte un horari
   * 
   * @param type Tipus de fitxatge (entrada o sortida)
   * @param hour Hora del fitxatge
   * @param timetable Horari indicat del fitxatge
   */
  private calculateDelay(type: string, hour: Date, timetable: any): number {

    console.log(timetable);

    // Buscar fitxatge del mateix tipus més pròxim
    var check = timetable.checks.filter(check => check.type == type).reduce(smaller);
    
    // Diferència d'hores en milisegons
    return hourDifference(check.hour, hour, false);
    

    // Calcular quin fitxatge està mes a prop d'una hora
    function smaller(check1, check2) {
      return hourDifference(check1.hour, hour, true) < hourDifference(check2.hour, hour, true) ? check1 : check2;
    }

    // Calcular quina hora està més a prop d'una tercera hora
    function hourDifference(hour1: string, hour2: Date, abs: boolean) {
      var hour = Number(hour1.split(':')[0]);
      var min = Number(hour1.split(':')[1]);

      var time = new Date();
      time.setHours(hour);
      time.setMinutes(min);
      time.setSeconds(0);
      
      // Diferència en milisegons
      return abs ? Math.abs(hour2.getTime() - time.getTime()) : (hour2.getTime() - time.getTime());
    }
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/'
  }

  /**
   * Calcular centre de treball actual segons coordenades.
   */
  private getCurrentWorkplace(resp, userId?: string): Promise<string> {
    return new Promise((resolve, reject) => {

      console.log(resp);
      var latLng = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);

      console.log(latLng);
        
      this.workplaceProvider.getWorkplacesOnce().subscribe(workplaces => {

        workplaces.map(workplace => {
          var polygon = new google.maps.Polygon({paths: workplace.coords});
          
          if(google.maps.geometry.poly.containsLocation(latLng, polygon)) {
            resolve(workplace.name);
          }
        })

        reject('Desconocido')
      })
    })
  }
}

/**
 * Obtenir un string amb hores, minuts i segons a partir de uns milisegons donats.
 * 
 * @param ms Milisegons
 */
function msToTime(ms): string {
  var tipus;
  if(ms > 0) tipus = 'Retraso: ';
  else tipus = 'Pronto: '

  ms = Math.abs(ms);

  var h, m, s;
  s = Math.floor(ms / 1000);
  m = Math.floor(s / 60);
  s = s % 60;
  h = Math.floor(m / 60);
  m = m % 60;

  var result = s + ' seg';
  if(m > 0) result = m + ' min, ' + result;
  if(h > 0) result = h + ' h, ' + result;

  return tipus + result;
}


// WEBPACK FOOTER //
// ./src/providers/check/check.ts